import React, { useEffect, useState } from "react";
// COMPONENTS
import MonitoringDeviceViewHeader from "./MonitoringDeviceViewHeader";
import MonitoringDeviceCard from "./MonitoringDeviceCard";
import MonitoringDeviceConfigurationsDrawer from "./MonitoringDeviceConfigurationsDrawer";
// CUSTOM HOOKS
import useWindowsHeight from "./useWindowsHeight";
import useGetAllMessagesTypes from "../../../customHooks/GET_requests/useGetAllMessagesTypes";
// INTERFACES
import {
	DeviceViewDataByServerInterface,
	DeviceViewDataByBankInterface,
	LayoutInterface,
} from "../../../interfaces/Monitoring.interface";
import { MessageTypeInterface } from "../../../interfaces/MessageType.interface";
// CONSTANTS
import { BLANK_DEVICE_VIEW_DATA_BY_BANK, BLANK_DEVICE_VIEW_DATA_BY_SERVER } from "../../../constants/monitoring";

export default function MonitoringDeviceView({ layouts }: { layouts: LayoutInterface[] }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const windowHeight = useWindowsHeight();

	// Configuración
	const itemHeight = 45;
	const cardPadding = 500;
	const availableSpace = windowHeight - cardPadding;

	// Cálculo de capacidad y columnas
	const itemsPerColumn = Math.max(1, Math.floor(availableSpace / itemHeight));

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [dataByServer, setDataByServer] = useState<DeviceViewDataByServerInterface[]>([
		{ ...BLANK_DEVICE_VIEW_DATA_BY_SERVER },
	]);
	const [dataByBank, setDataByBank] = useState<DeviceViewDataByBankInterface[]>([
		{ ...BLANK_DEVICE_VIEW_DATA_BY_BANK },
	]);
	const [totalUnites, setTotalUnites] = useState<{
		elevators: number;
		escalators: number;
		movingwalks: number;
		gpio: number;
	}>({
		elevators: 0,
		escalators: 0,
		movingwalks: 0,
		gpio: 0,
	});
	const [deviceMessageTypes, setDeviceMessageTypes] = useState<MessageTypeInterface[]>([]);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { messagesTypes } = useGetAllMessagesTypes();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const buildDataByServer = () => {
		const newData: DeviceViewDataByServerInterface[] = [];
		// Extract data by servers
		layouts.forEach((layout: any) => {
			newData.push({
				idServer: layout.idServer,
				nameServer: layout.nameServer,
				lifts: [],
				liftsChunks: [],
			});
		});
		//
		const uniqueData = Array.from(new Map(newData.map((item) => [item.idServer, item])).values());
		//
		let totalElevators = 0;
		let totalEscalators = 0;
		let totalMovingWalks = 0;
		let totalGpio = 0;
		//
		uniqueData.forEach((item: DeviceViewDataByServerInterface, indexItem: number) => {
			layouts.forEach((layout: any) => {
				if (item.idServer === layout.idServer) {
					layout.lifts.forEach((lift: any) => {
						if (lift.type === "ELEVATOR") {
							totalElevators += 1;
						}
						if (lift.type === "ESCALATOR") {
							totalEscalators += 1;
						}
						if (lift.type === "MOVINGWALK") {
							totalMovingWalks += 1;
						}
						if (lift.type === "GPIO") {
							totalGpio += 1;
						}
						uniqueData[indexItem].lifts.push({ name: lift.name, id: lift.id, bank: layout.name });
					});
				}
			});
		});
		setTotalUnites({
			elevators: totalElevators,
			escalators: totalEscalators,
			movingwalks: totalMovingWalks,
			gpio: totalGpio,
		});
		setDataByServer(uniqueData);
	};

	const buildDataByBank = () => {
		const newData: DeviceViewDataByBankInterface[] = [];
		// Extract data by servers
		layouts.forEach((layout: any) => {
			newData.push({
				idBank: layout.idBank,
				nameBank: layout.nameServer,
				lifts: layout.lifts,
				liftsChunks: [],
			});
		});
		setDataByBank(newData);
	};

	const buildNewMessagesTypes = () => {
		const newData = messagesTypes.map((message: MessageTypeInterface) => ({
			...message,
			active: true,
		}));
		setDeviceMessageTypes(newData);
	};

	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		buildDataByBank();
		buildDataByServer();
	}, [layouts]);

	useEffect(() => {
		buildNewMessagesTypes();
	}, [messagesTypes]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div style={{ padding: "10px" }}>
			<MonitoringDeviceConfigurationsDrawer
				messagesTypes={deviceMessageTypes}
				setDeviceMessageTypes={setDeviceMessageTypes}
			/>
			<MonitoringDeviceViewHeader totalUnites={totalUnites} deviceMessageTypes={deviceMessageTypes} />
			<div style={{ overflowX: "scroll" }}>
				<MonitoringDeviceCard dataByBank={dataByBank} dataByServer={dataByServer} itemsPerColumn={itemsPerColumn} />
			</div>
		</div>
	);
}
